// src/App.js

import React, { useEffect } from 'react';
import MainComponent from './components/MainComponent';
import ErrorBoundary from './components/ErrorBoundary';
import { getCurrentApp, getAppId } from './services/appService';

function App() {
  const currentApp = getCurrentApp();
  const appId = getAppId();

  useEffect(() => {
    // Initialize Trello Power-Up
    window.TrelloPowerUp.initialize({
      'board-buttons': function(t, options) {
        return [{
          icon: {
            dark: currentApp.icon,
            light: currentApp.icon
          },
          text: currentApp.name,
          callback: function(t) {
            const pathPrefix = appId !== 'flowGenerator' ? `/${appId}` : '';
            return t.popup({
              title: currentApp.name,
              url: t.signUrl(`${pathPrefix}/index.html`),
              width: 340,
              height: 350,
            });
          }
        }];
      }
    });
  }, [currentApp, appId]);

  return (
    <div className="App">
      <ErrorBoundary>
        <MainComponent />
      </ErrorBoundary>
    </div>
  );
}

export default App;